import { render, staticRenderFns } from "./semui-dropdown.vue?vue&type=template&id=5d8edd04&scoped=true"
import script from "./semui-dropdown.vue?vue&type=script&lang=js"
export * from "./semui-dropdown.vue?vue&type=script&lang=js"
import style0 from "./semui-dropdown.vue?vue&type=style&index=0&id=5d8edd04&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8edd04",
  null
  
)

export default component.exports